var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon35(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(-1009 -4228)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(1009 4228)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_smoking",
    d: "M12.969,0a9.129,9.129,0,0,0,.542,3.615,6.179,6.179,0,0,0,4.316,3.569,22.434,22.434,0,0,1,4.078,1.3c1.03.53,1.439.928,1.439,1.892h2.594a4.826,4.826,0,0,0-2.847-4.2,22.347,22.347,0,0,0-4.6-1.5,3.255,3.255,0,0,1-2.571-2.034A7.133,7.133,0,0,1,15.563,0Zm6.484,0V2.594a9.2,9.2,0,0,1,3.574.659A2.286,2.286,0,0,1,24.646,5.3a1.3,1.3,0,0,0,1.292,1.188,2.006,2.006,0,0,1,1.839,1.044,5.368,5.368,0,0,1,.755,2.847h2.594a7.717,7.717,0,0,0-1.191-4.286,4.873,4.873,0,0,0-3.085-1.953A5.3,5.3,0,0,0,24.114.9,11.243,11.243,0,0,0,19.453,0ZM0,11.672v7.781H31.125V11.672Zm2.594,2.594h20.75v2.594H2.594Zm23.344,0h2.594v2.594H25.938Z",
    transform: "translate(1023.438 4248.273)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon35);
export default __webpack_public_path__ + "static/media/facilityIcon35.b2e117919f1cd728d956e54a393c4566.svg";
export { ForwardRef as ReactComponent };